import { draggable } from "common";
import { FilterGroup } from './FilterGroup';
import { FilterDragHandler } from './FilterDragHandler';
import { FilterInfoInstance, SharedFilterInstance } from './FilterInfoInstance';
import { UserFilterGroupInstance } from "./UserFilterGroupInstance";
import { setUserFilters, userFilters } from "./UserFilterStore";
import { viewFilters as api } from 'st-app/api';

export class FilterDropHandler implements draggable.IDropHandler {
    name: string = 'st-view-filter';
    group: UserFilterGroupInstance;
    filter: FilterInfoInstance;

    constructor(group: UserFilterGroupInstance, filter: FilterInfoInstance) {
        this.group = group;
        this.filter = filter;
    }

    dropFilter(filter: FilterInfoInstance, dropBelow: boolean) {
        const filters = userFilters.allFilters
            .map(f => new FilterInfoInstance(f))
            .sort((a, b) => a.order - b.order);

        const dstFilter = filters.find(f => f.filterGU === this.filter.filterGU);
        const srcFilter = filters.find(f => f.filterGU === filter.filterGU);

        if (srcFilter && dstFilter) {
            const adj = dropBelow ? 1 : 0;
            filters.splice(filters.indexOf(srcFilter), 1)
            filters.splice(filters.indexOf(dstFilter) + adj, 0, srcFilter);
        }

        let idx = 0;
        for (const filter of filters) {
            filter.order = idx++;
        }

        api.UpdateFilterOrder(filters);
        setUserFilters('allFilters', filters);
    }

    async drop(ev: DragEvent, dragHandler: draggable.IDragHandler) {
        const item = (ev.target as Element)?.closest('li');
        if (item && dragHandler instanceof FilterDragHandler) {
            const dropBelow = item.classList.contains('drag-hover-bottom');
            if (dragHandler.filter instanceof SharedFilterInstance) {
                const srcFilter = await userFilters.acceptSharedFilter(dragHandler.filter, this.group.filterGroupGU);
                if (srcFilter) {
                    this.dropFilter(srcFilter, dropBelow);
                }
            }
            else {
                this.dropFilter(dragHandler.filter, dropBelow);
            }
        }

        this.filter.isDropTarget[1](false);
    }

    enter(ev: DragEvent, dragHandler: draggable.IDragHandler): void {
        this.filter.isDropTarget[1](true);
    }

    leave(ev: DragEvent, dragHandler: draggable.IDragHandler): void {
        this.filter.isDropTarget[1](false);

        const item = (ev.target as Element)?.closest('li');
        if (item) {
            item.classList.remove('drag-hover-bottom');
            item.classList.remove('drag-hover-top');
        }
    }

    over(ev: DragEvent, dragHandler: draggable.IDragHandler): void {
        const item = (ev.target as Element)?.closest('li');

        if (item) {
            const rect = item.getBoundingClientRect();

            if (ev.pageY < rect.top + (rect.height / 2)) {
                item.classList.add('drag-hover-top');
                item.classList.remove('drag-hover-bottom');
            }
            else {
                item.classList.add('drag-hover-bottom');
                item.classList.remove('drag-hover-top');
            }
        }
    }
}
